import { render, staticRenderFns } from "./ModalConfirm.vue?vue&type=template&id=5b0fbc28&scoped=true&"
import script from "./ModalConfirm.vue?vue&type=script&lang=ts&"
export * from "./ModalConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ModalConfirm.vue?vue&type=style&index=0&id=5b0fbc28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0fbc28",
  null
  
)

export default component.exports